import React from "react";
import { DefaultCompanyLogoIcon } from "Components/Icons";
import useStyles from "./styles";

type ProviderIconProps = {
  icon?: string;
};

const ProviderIcon = ({ icon }: ProviderIconProps) => {
  const src =
    icon && icon.startsWith("http")
      ? icon
      : `${process.env.REACT_APP_RAILS_APP_HOSTNAME}${icon}`;
  const classes = useStyles({ src });
  return icon ? (
    <div className={classes.providerIcon} />
  ) : (
    <DefaultCompanyLogoIcon />
  );
};

export default ProviderIcon;
